<template>
  <div id="powered">
    <div class="powered">
      <div class="name">江苏省企业信息化协会创建</div>
      <div class="clearfix">
        <div class="powered-by">Powered by</div>
        <a href="http://www.gongyi.la/">
          <img src="@/assets/images/logo.png">
        </a>
      </div>
      <div class="distance" :style="{height:height}"></div>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      height: '',
    }
  }

</script>
<style lang='less' scoped>
  

  #powered {
    background: transparent;
  }

  .powered {
    border-top: 1px dashed #eee;
    text-align: center;
    margin: 20/@rem-size 24/@rem-size 0;
    color: #b2b2b2;
    font-size: 24/@rem-size;
    padding-top: 25/@rem-size;

    .name {
      padding-bottom: 10/@rem-size;
    }

    .powered-by {
      display: inline-block;
      line-height: 42/@rem-size;
    }

    a {
      width: 124/@rem-size;
      display: inline-block;
      margin-left: 10/@rem-size;
    }

    img {
      display: block;
      position: relative;
      top: 12/@rem-size;
    }

    .distance {
      height: 140/@rem-size;
      width: 100%;
    }
  }

</style>
